import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import repairImageAvif1920 from "@/assets/about-repair-1920.avif";
import repairImageAvif1280 from "@/assets/about-repair-1280.avif";
import repairImageAvif640 from "@/assets/about-repair-640.avif";
import repairImageJpg1920 from "@/assets/about-repair-1920.jpg";
import repairImageJpg1280 from "@/assets/about-repair-1280.jpg";
import repairImageJpg640 from "@/assets/about-repair-640.jpg";
import { useLanguage } from "@/i18n/LanguageContext";

const AboutSection = () => {
  const { t } = useLanguage();

  const advantages = [
    t("about.adv1"), t("about.adv2"), t("about.adv3"),
    t("about.adv4"), t("about.adv5"), t("about.adv6"),
  ];

  return (
    <section id="about" className="py-24 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <picture>
                <source
                  type="image/avif"
                  srcSet={`${repairImageAvif640} 640w, ${repairImageAvif1280} 1280w, ${repairImageAvif1920} 1920w`}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />

                <source
                  type="image/jpeg"
                  srcSet={`${repairImageJpg640} 640w, ${repairImageJpg1280} 1280w, ${repairImageJpg1920} 1920w`}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />

                <img
                  src={repairImageJpg1280}
                  alt="Warsztat diagnostyki sterowników Gendera Service"
                  className="w-full h-full object-cover"
                  width={1200}
                  height={900}
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </div>
            <div className="absolute -bottom-8 -right-8 bg-accent text-accent-foreground p-8 rounded-2xl shadow-xl hidden lg:block">
              <div className="text-5xl font-bold">20+</div>
              <div className="text-lg font-medium">{t("about.yearsOnMarket")}</div>
            </div>
          </div>

          <div>
            <span className="inline-block text-accent font-semibold mb-4 uppercase tracking-wider text-sm">{t("about.label")}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">{t("about.title")}</h2>
            <p className="text-muted-foreground text-lg mb-6 leading-relaxed">{t("about.p1")}</p>
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed">{t("about.p2")}</p>

            <ul className="space-y-4 mb-8">
              {advantages.map((advantage) => (
                <li key={advantage} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" />
                  <span className="text-foreground">{advantage}</span>
                </li>
              ))}
            </ul>

            <Button size="lg" className="bg-accent hover:bg-orange-hover text-accent-foreground font-semibold px-8 hidden">
              {t("about.cta")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;